class OtherOrganization {
  constructor(title, phoneNumber) {
    this.title = title;
    this.phoneNumber = phoneNumber;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      otherOrganizationId: null,
      searchTitle: '',
      disabelConfirm: false,
      addFlag: false,
      modalTitle: '',
      showAddEditModal: false,
      modalIcon: '',
      provinceTitle: '',
      otherOrganizationManagmentInformationTableHeaders: [
        { text: 'ردیف', value: 'counter', align: 'center' },
        { text: 'عنوان', value: 'title', align: 'center' },
        { text: 'شماره تلفن', value: 'phoneNumber', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
      otherOrganizationphoneNumbers: [],
    };
  },
  methods: {
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.modalTitle = 'افزودن ارگان';
        this.modalIcon = 'mdi-plus';
        this.addFlag = true;
        this.confimType = 'add';
        this.showAddEditModal = true;
      } else if (type == 2) {
        this.modalTitle = 'ویرایش ارگان';
        this.modalIcon = 'mdi-pencil';
        this.confimType = 'edit';
        this.addFlag = false;
        this.getOtherOrganizationFunction(id);
        this.showAddEditModal = true;
      }
    },
    cancelAddEditFunction: function () {
      this.otherOrganization = new OtherOrganization('', '');
      this.otherOrganizationphoneNumbers = [];
      this.showAddEditModal = false;
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addOtherOrganizationFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش ارگان';
        this.$refs.confirm.text = 'از ویرایش ارگان اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف ارگان';
        this.$refs.confirm.text = 'از حذف ارگان اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addOtherOrganizationFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editOtherOrganizationFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteOtherOrganizationFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.otherOrganizationId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
    addPhoneNumber: function () {
      for (let i = 0; i < this.otherOrganizationphoneNumbers.length; i++) {
        if (this.otherOrganizationphoneNumbers[i].text == '') {
          return;
        }
      }
      this.otherOrganizationphoneNumbers.push({
        text: '',
        id: this.otherOrganizationphoneNumbers.length + 1,
      });
    },
    removePhoneNumber: function (id) {
      for (let i = 0; i < this.otherOrganizationphoneNumbers.length; i++) {
        if (id == this.otherOrganizationphoneNumbers[i].id) {
          this.otherOrganizationphoneNumbers.splice(i, 1);
          break;
        }
      }
    },
  },
};
